<script>
    import { checkbox } from 'vue-strap';

    export default {
        components: { checkbox },
        props: {
            solicitacao: {
                required: true,
                type: Object,
            },
            habilitarOuDesabilitarTermo:  { 
              required: true,
              type: Boolean,
            },
        },
        data() {
            return {
                configuracao: this.$storage.configuracao(),
                usuario: this.$storage.usuario(),
            }
        },
        methods: {
            retornaEmpresa() {
                let item = this.solicitacao.itensSolicitacaoCompra.find(i => i.tipoCompra == '13' && i.executora == '2')
                return item ? item.empresaProduto : "";
            },
            removeErro(field) {
                var pos = -1;

                while (this.errors.has(field)) {
                    for (var i = 0; i < this.errors.items.length; i++) {
                        if (this.errors.items[i].field == field) {
                            pos = i
                            break
                        }
                    }

                    if (pos > -1) {
                        this.errors.items.splice(pos, 1)
                    }
                }
            },
            removeErroAceite() {
                this.removeErro('aceite');
            },
            adicionaErroAceite() {
                if (!this.errors.has('aceite')) {
                    this.errors.items.push(
                        { "id": "_y980569955l9f3565sd", "field": "aceite", "msg": "É obrigatório aceitar o termo acima", "rule": "required", "scope": null }
                    )
                }
            },
        },
        watch: {
            'solicitacao.aceite': 'removeErroAceite',
        }
    }
</script>

<template>
    <div>
        <div class="row" v-if="habilitarOuDesabilitarTermo">
            <div class="col-xs-12">
                <span style="font-size: 18px;">
                    Pelo presente instrumento, eu, Sr(a). <strong>{{this.usuario.nome}}</strong>, portador(a) do documento nº <strong>{{this.usuario.documento}}</strong>,
                    informo minha ciência e minha anuência no que se refere a ética e ao sigilo de dados a mim repassados pela FUSP, incluindo, mas não se limitando,
                    os dados de login e da senha de acesso ao portal de compras da empresa <strong>{{this.retornaEmpresa()}}</strong>, para o processamento da Solicitação de Compra FUSP do Projeto <strong>{{this.solicitacao.projeto.nomeProjeto}}</strong>.
                    Diante do recebimento de tais informações, me comprometo utilizar o portal de compras somente para o fim que me foi previamente autorizado pela FUSP, <span style="text-decoration: underline;"><strong>sendo vedada</strong></span>, assim, as seguintes condutas:
                    <br /><br />
                    a. a divulgação de tais dados e informações a terceiros;<br />
                    b. utilização de dados da fundação e do portal para atividades não previamente autorizadas e/ou não vinculadas ao projeto ou à FUSP;<br />
                    c. a não alteração de dados cadastrais já incluídos pela FUSP. Caso o fornecedor possibilite agregar endereço de entrega, a FUSP autoriza.<br />
                    d. ter ciência que a FUSP não está preparada para receber embalagens de grande porte e com peso superior a 25kgs.<br /><br />
                </span>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group required" :class="{'has-error': errors.has('aceite')}">
                    <div class="checkbox">
                        <checkbox v-model="solicitacao.aceite" value="1" type="primary">
                            Li e aceito o termo acima
                        </checkbox>
                    </div>

                    <p class="text-danger" v-show="errors.has('aceite')">{{ errors.first('aceite') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormComprasOnlineTermo.vue